module.exports = __webpack_public_path__ + "media/common/statics/lesson_icon/2-2623ff1120f7366e1ff5a8ecb60e6ca4.png";